import type { Action, Permission } from './types'
import type { SubjectRawRule } from '@casl/ability'

import { createMongoAbility } from '@casl/ability'

type Permissions = Array<
SubjectRawRule<Action, Permission, Record<string, string | number>>
>

export const ability = createMongoAbility([])

export const setPermissions = (rules: Permissions): void => {
  ability.update(rules || [])
}
